import Repository from './Repository'

const resource = '/companies'

export default {
  async getListCompanies(params = {}) {
    try {
      return await Repository.get(`${resource}`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async update(id, data, reload = false, config = {}) {
    try {
      return await Repository.patch(`${resource}/${id}`, data, config, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateEndCallStatus(data) {
    try {
      return await Repository.patch(`${resource}/update/end-call-status`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async saveCompany (data, reload = false, config = {}) {
    try {
      return await Repository.post(`${resource}`, data, {}, config, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async findOneById(id) {
    try {
      return await Repository.get(`${resource}/${id}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async findOneByField(field, condition, reload = false, params = {}) {
    try {
      return await Repository.get(`${resource}/find-one/${field}/${condition}`, params, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async softDeleteCompany (id) {
    try {
      return await Repository.delete(`${resource}/${id}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateCompanyAdditionalInfo(data) {
    try {
      return await Repository.patch(`${resource}/update/company-additional-info`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
